import { render, staticRenderFns } from "./BackupAutomaticSwitcher.vue?vue&type=template&id=4ea5a5c3&scoped=true"
import script from "./BackupAutomaticSwitcher.vue?vue&type=script&lang=js"
export * from "./BackupAutomaticSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BackupAutomaticSwitcher.vue?vue&type=style&index=0&id=4ea5a5c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea5a5c3",
  null
  
)

export default component.exports